const SUPPORTED_LOCALES = ['es', 'en', 'id', 'vi', 'th'];

module.exports = SUPPORTED_LOCALES;
